import Select from "react-select";
import { SearchFormContainer } from "../../style/contents/common/common";
import { useState } from "react";

type OptionType = { value: string; label: string };

const tableSort: OptionType[] = [
  { value: "10", label: "10개씩 보기" },
  { value: "20", label: "20개씩 보기" },
  { value: "50", label: "50개씩 보기" },
];

interface Props {
  onSearch: (keyword: string) => void;
  onPageSizeChange: (size: string) => void;
  pageSize?: string; // ✅ 상위에서 받은 값
  pageSizeHidden?: boolean;
}

const SearchForm = ({
  onSearch,
  onPageSizeChange,
  pageSize,
  pageSizeHidden,
}: Props) => {
  const [keyword, setKeyword] = useState("");

  const handleSubmit = () => {
    onSearch(keyword);
  };

  const handlePageSizeChange = (selectedOption: any) => {
    onPageSizeChange(selectedOption.value);
  };

  return (
    <SearchFormContainer>
      {!pageSizeHidden && (
        <div className="l">
          <Select
            className="search-select"
            classNamePrefix="react-select"
            options={tableSort}
            onChange={handlePageSizeChange}
            defaultValue={tableSort[0]} // 기본값 설정
            components={{
              IndicatorSeparator: () => null,
            }}
            value={tableSort.find((option) => option.value === pageSize)} // ✅ 객체로 매칭
          />
        </div>
      )}
      <div className="r">
        <div className="input-box">
          <input
            type="text"
            placeholder="검색어 입력"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSearch?.(keyword);
              }
            }}
          />
        </div>
        <button type="button" onClick={handleSubmit}>
          검색
        </button>
      </div>
    </SearchFormContainer>
  );
};

export default SearchForm;
